import {useQuery} from 'react-query';

import {VideoService} from '../types';
import {getPreviewLink} from '../utils/video';

export function usePreviewUrl({
    service,
    id,
    isEnabled = true
}: {
    service?: VideoService;
    id?: string;
    isEnabled?: boolean;
}) {
    const isQueryDisabled = !isEnabled || !service || !id;

    return useQuery(
        `preview/${service}/${id}`,
        async () => {
            return getPreviewLink(service!, id!);
        },
        {
            enabled: !isQueryDisabled
        }
    );
}
